import { h, render } from 'vue';
import Share from './Share.vue';

const mount = (component, { props, children, element, app } = {}) => {
  let el = element ? element : document.createElement('div');
  let vNode = h(component, props, children);
  if (app && app._context) vNode.appContext = app._context;

  render(vNode, el);

  const destroy = () => {
    if (el) {
      render(null, el);
      document.body.removeChild(el);
    }
    el = null;
    vNode = null;
  };

  return { vNode, destroy, el };
};

const instances = [];
const instance = (options) => {
  const o = typeof options === 'string' ? { type: options } : options;
  const component = mount(Share, { props: { modelValue: true, type: 'browser', duration: 0, ...o } });
  instance.clear();
  document.body.appendChild(component.el);
  instances.push(component);
  /* eslint-disable */
  return component;
};
instance.show = function loading(type, options = {}) {
  return instance({  duration: 0, type, ...options });
};


instance.clear = function clear() {
  instances.forEach((instance) => {
    instance.destroy();
  });
};

export default instance;
